// The organization context a tab acts as. Super Admins can switch the viewed
// organization at any time from another tab; these constants let the API tell
// a tab that its context went stale instead of silently attributing writes to
// the wrong organization.

// Request header carrying the organization this tab believes it is acting as.
// Set globally on axios once the current user is known; the API rejects
// mutating requests when it no longer matches the server-side selection.
export const ORGANIZATION_CONTEXT_HEADER = 'X-Organization-Context'

// ProblemDetails `type` returned by the API when a write is rejected for a
// stale organization context.
export const ORGANIZATION_CONTEXT_MISMATCH = 'organization-context-mismatch'

// BroadcastChannel name used to converge other tabs right after an
// organization switch, rather than waiting for one of their writes to fail.
export const ORGANIZATION_CONTEXT_CHANNEL = 'organization-context'

// True when the error is the API's stale-organization-context rejection.
export function isOrganizationContextMismatch(error: unknown): boolean {
  const response = (
    error as { response?: { status?: number; data?: { type?: string } } }
  )?.response
  return (
    response?.status === 409 &&
    response?.data?.type === ORGANIZATION_CONTEXT_MISMATCH
  )
}
